<script setup lang="ts">
import { api } from "@/api";
import { useFacade } from "@/facades";
import { alerts } from "../../common/alert.common";

const props = defineProps<{
    prev: string;
    name: string;
    recipient: string;
    invoiceId: string;
}>();

const f = useFacade();

async function revertPayment() {
    const msg = `Apakah anda yakin akan membatalkan pembayaran tagihan ${props.name} atas nama ${props.recipient}? Aksi ini tidak dapat dibatalkan.`;

    if (await alerts.confirm.warningText({ title: "PERHATIAN", text: msg })) {
        await api.financeInvoice
            .revert(props.invoiceId)
            .onSuccess(alerts.basic.success(() => f.route.reload()))
            .onFailure(alerts.basic.failure())
            .execute();
    }
}
</script>

<template>
    <div class="inline-flex flex-row items-center gap-2 big-button bg-red-600" @click="revertPayment">
        <i class="pi pi-undo text-xl! font-bold!"></i>
        <span class="font-bold">Batalkan Pembayaran Tagihan</span>
    </div>
</template>

<style scoped>
@reference "@/styles/main.css";

.big-button {
    @apply px-8 py-2 text-white rounded-md shadow-md hover:cursor-pointer;
}
</style>
